export default function (Alpine) {
  Alpine.data('navigation', function (scope = {}) {
    const context = {
      items: [],
      current: null,
      parent: null,
      push(item) {
        this.parent = this.current
        this.current = item
        this.items.push(item)
      },
      pop() {
        this.items.pop()
        this.current = this.items[this.items.length - 1] || null
        this.parent = this.items[this.items.length - 2] || null
      },
      root() {
        this.items = []
        this.current = null
        this.parent = null
      },
      depth() {
        return this.items.length
      },
      active(item) {
        return this.items.indexOf(item) !== -1
      },
      is(item) {
        return this.current == item
      },
    }

    return {
      ...scope,
      nav: context,
    }
  })
}
